import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ea7bdac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section work-modes" }
const _hoisted_2 = { class: "work-modes__layout" }
const _hoisted_3 = { class: "work-modes__list" }

import SectionHeading from "@/components/SectionHeading.vue";
import { workModes } from "@/data/profile";

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkModes',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SectionHeading, {
        eyebrow: "Anknüpfung",
        title: "Vecura, Verantwortung, ausgewählte Projekte.",
        description: "Mein Schwerpunkt liegt auf Vecura. Darüber hinaus passen Gespräche, wenn Softwarearchitektur, KI/RAG, technische Richtung und Organisationswirkung zusammenkommen."
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workModes), (mode) => {
          return (_openBlock(), _createElementBlock("article", {
            key: mode.title
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(mode.status), 1),
              _createElementVNode("h3", null, _toDisplayString(mode.title), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(mode.description), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})